import { render, staticRenderFns } from "./UpdateRepo.vue?vue&type=template&id=421af50a&scoped=true"
import script from "./UpdateRepo.vue?vue&type=script&lang=js"
export * from "./UpdateRepo.vue?vue&type=script&lang=js"
import style0 from "./UpdateRepo.vue?vue&type=style&index=0&id=421af50a&prod&lang=scss&scoped=true"
import style1 from "vue-select/dist/vue-select.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421af50a",
  null
  
)

export default component.exports